export default "__VITE_ASSET__DTsCxt6W__"